import { axios } from '@/utils/request'
import api from './index'
// 查询预算模板
export function getTemplateAll(data) {
    return axios({
      url: api.gateway_act + 'budget/templateAll',
      method: 'get',
      params: data
    })
  }
  //模板提交
export function postApply(parameter) {
    return axios({
      url: api.gateway_act + 'budget/template',
      method: 'post',
      data: parameter
    })
  }
  //删除模板
  export function delTemplate(data) {
    return axios({
      url: api.gateway_act + 'budget/templateDelete',
      method: 'get',
      params: data
    })
  }
 //启用
 export function templateDisable(data) {
  return axios({
    url: api.gateway_act + 'budget/templateDisable',
    method: 'get',
    params: data
  })
}
//预算详情 查询预算模板
export function templateDetail(parameter) {
  return axios({
    url: api.gateway_act + 'budget/select/plan',
    method: 'get',
    params: parameter
  })
}
//提交所选公司部门
export function addDept(parameter) {
	return axios({
		url:  api.gateway_act + 'budget/select/dept',
		method: 'POST',
		data: parameter
	})
}
//获取子预算
export function getSubBudget(parameter) {
  return axios({
    url: api.gateway_act + 'detail',
    method: 'get',
    params: parameter
  })
}
//获取子预算
export function addSubDetail(parameter) {
  return axios({
    url: api.gateway_act + 'budget/select/detail',
    method: 'POST',
		data: parameter
  })
}
//预算编辑后保存
export function saveModel(parameter) {
  return axios({
    url: api.gateway_act + 'budget/save/dept',
    method: 'POST',
		data: parameter
  })
}
//发布预算模板
export function publistModel(data) {
  return axios({
    url: api.gateway_act + 'budget/state',
    method: 'get',
    params: data
  })
}
//修改预算名字
export function editName(data) {
  return axios({
    url: api.gateway_act + 'budget/update/name',
    method: 'get',
    params: data
  })
}
//上传预算文件
export function fileUpload(parameter) {
  return axios({
    url: api.gateway_act + 'budget/upload',
    method: 'POST',
		data: parameter
  })
}
//获取预算详情
export function lookData(data) {
  return axios({
    url: api.gateway_act + 'budget/select/look',
    method: 'get',
    params: data
  })
}
//删除父级节点
export function deleteArray(parameter) {
  return axios({
    url: api.gateway_act + 'budget/delete/array',
    method: 'POST',
		data: parameter
  })
}
//查看当前预算
export function selectMoney(parameter) {
  return axios({
    url: api.gateway_act + '/budget/select/money',
    method: 'POST',
		data: parameter
  })
}
// 手动调剂成功
export function resetMoney(parameter) {
  return axios({
    url: api.gateway_act + '/budget/reset/money',
    method: 'POST',
		data: parameter
  })
}
// 金额修改
export function resetMoneyEdit(parameter) {
  return axios({
    url: api.gateway_act + '/budget/updateBudgetMoney',
    method: 'POST',
		data: parameter
  })
}
//获取项目详情
export function projectAmountApply(data) {
  return axios({
    url: api.gateway_act + 'project_amount_apply/projectInfo',
    method: 'get',
    params: data
  })
}
// 新增申请
export function salarySave(parameter) {
  return axios({
    url: api.gateway_act + 'project_amount_apply/save',
    method: 'POST',
		data: parameter
  })
}
//获取项目申请编号
export function salaryCode(data) {
  return axios({
    url: api.gateway_act + 'project_amount_apply/code',
    method: 'get',
    params: data
  })
}
//获取修改金额详情
export function salaryDetail(id) {
  return axios({
    url: api.gateway_act + 'project_amount_apply/biz/' + id,
    method: 'get',
  })
}
//修改导出
export function apply_downlodPdf(data) {
	return axios({
		url: api.gateway_act + 'project_amount_apply/export_pdf',
		method: 'get',
		params: data
	})
}
// 新增投标申请
export function bidSave(parameter) {
  return axios({
    url:  '/act/bid/save',
    method: 'POST',
		data: parameter
  })
}
//获取招标申请编号
export function bidCode(data) {
  return axios({
    url: api.gateway_act + 'bid/code',
    method: 'get',
    params: data
  })
}
//获取项目信息
export function contractProject(data) {
  return axios({
    url: api.gateway_act + 'contract_project/getInfo',
    method: 'get',
    params: data
  })
}
// 新增项目修改申请
export function contractProjectSave(parameter) {
  return axios({
    url:  '/act/contract_project/save',
    method: 'POST',
		data: parameter
  })
}
//获取项目信息修改列表
export function projectList(data) {
  return axios({
    url: api.gateway_act + 'project_amount_apply/list',
    method: 'get',
    params: data
  })
}
//获取合同信息
export function projectType(data) {
  return axios({
    url: api.gateway_act + 'contract_project/getType',
    method: 'get',
    params: data
  })
}
//获取项目信息详情
export function projectDetail(id) {
  return axios({
    url: api.gateway_act + 'contract_project/detail/' + id,
    method: 'get',
  })
}
//获取中止项目信息详情
export function terminationDetail(data) {
  return axios({
    url: api.gateway_act + '/project/terminate',
    method: 'get',
    params: data
  })
}